(() => {
  const config = window.TacSlaps || {};
  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-backdrop]');
  const cartItems = document.querySelector('[data-cart-items]');
  const cartTotal = document.querySelector('[data-cart-total]');
  const shippingProgress = document.querySelector('[data-shipping-progress]');
  const toast = document.querySelector('[data-toast]');
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character]));
  const money = cents => new Intl.NumberFormat(undefined, { style: 'currency', currency: config.currency || 'USD' }).format(Number(cents || 0) / 100);

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), 1900);
  }
  function openCart(open = true) {
    if (!drawer || !backdrop) return;
    drawer.classList.toggle('open', open);
    backdrop.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('cart-drawer-open', open);
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
    if (shippingProgress) shippingProgress.textContent = cart.total_price >= 7500 ? 'Free U.S. shipping unlocked.' : `Spend ${money(7500 - cart.total_price)} more for free U.S. shipping.`;
    if (!cartItems) return;
    if (!cart.items.length) { cartItems.innerHTML = '<p class="empty">Your cart is ready for some slaps.</p>'; return; }
    cartItems.innerHTML = cart.items.map(item => {
      const properties = Object.entries(item.properties || {}).filter(([key, value]) => value && !key.startsWith('_')).map(([key, value]) => {
        const isFile = String(value).includes('/uploads/');
        return `<small><b>${escapeHtml(key)}:</b> ${isFile ? `<a href="${escapeHtml(value)}" target="_blank" rel="noopener">Artwork attached</a>` : escapeHtml(value)}</small>`;
      }).join('');
      return `<div class="cart-item"><strong>${escapeHtml(item.product_title)}</strong><small>${escapeHtml(item.variant_title || '')}</small>${properties}<div><b>${money(item.final_line_price)}</b><button type="button" data-cart-remove="${escapeHtml(item.key)}">Remove</button></div></div>`;
    }).join('');
  }
  async function refreshCart() {
    const response = await fetch(config.cartGet, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart could not be loaded.');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  document.querySelectorAll('[data-cart-open]').forEach(trigger => trigger.addEventListener('click', async event => {
    event.preventDefault();
    try { await refreshCart(); } catch (error) { showToast(error.message); }
    openCart(true);
  }));
  document.querySelector('[data-cart-close]')?.addEventListener('click', () => openCart(false));
  backdrop?.addEventListener('click', () => openCart(false));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') openCart(false); });
  cartItems?.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-remove]');
    if (!button) return;
    button.disabled = true;
    try {
      const response = await fetch(config.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.cartRemove, quantity: 0 }) });
      if (!response.ok) throw new Error('That item could not be removed.');
      renderCart(await response.json());
    } catch (error) { showToast(error.message); button.disabled = false; }
  });

  document.querySelectorAll('.product-form').forEach(productForm => {
    const select = productForm.querySelector('select[name="id"]');
    const priceNode = document.querySelector('[data-product-price]');
    const add = productForm.querySelector('[data-product-add]');
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (priceNode && option?.dataset.price) priceNode.textContent = money(option.dataset.price);
      const available = option?.dataset.available === 'true';
      if (add) { add.disabled = !available; add.textContent = available ? 'Add to cart' : 'Sold out'; }
    });
    const fileInput = productForm.querySelector('[data-product-artwork]');
    const fileLabel = productForm.querySelector('[data-product-file-label]');
    const fileStatus = productForm.querySelector('[data-product-file-status]');
    const delivery = productForm.querySelector('[data-product-artwork-delivery]');
    fileInput?.addEventListener('change', () => {
      const file = fileInput.files[0];
      if (!file) { fileLabel.textContent = 'Choose PDF'; fileStatus.textContent = 'Corrupt, password-protected, or unusable PDFs pause production until replaced.'; fileStatus.className = 'product-file-status'; if (delivery) delivery.value = 'Send PDF after checkout'; return; }
      const valid = file.name.toLowerCase().endsWith('.pdf') && (!file.type || file.type === 'application/pdf');
      if (!valid) { fileInput.value = ''; fileLabel.textContent = 'Choose PDF'; fileStatus.textContent = 'That selection is not an actual PDF. Please choose a .pdf file.'; fileStatus.className = 'product-file-status error'; if (delivery) delivery.value = 'Send PDF after checkout'; showToast('PDF files only'); return; }
      fileLabel.textContent = 'PDF selected'; fileStatus.textContent = `Ready: ${file.name}`; fileStatus.className = 'product-file-status success'; if (delivery) delivery.value = 'PDF uploaded';
    });
  });

  const builder = document.querySelector('[data-sticker-builder]');
  if (!builder) return;
  const form = builder.querySelector('#TacBuilderForm');
  const productNode = builder.querySelector('[data-builder-product]');
  const optionsNode = builder.querySelector('[data-builder-options]');
  const variantInput = builder.querySelector('[data-variant-id]');
  const addButton = builder.querySelector('[data-add-to-cart]');
  const errorNode = builder.querySelector('[data-builder-error]');
  let product = null;
  let optionNames = [];
  try { product = JSON.parse(productNode.textContent); optionNames = JSON.parse(optionsNode.textContent); } catch (error) { product = null; }

  const catalog = {
    vinyl: { label: 'Standard Vinyl', multiplier: 1, note: 'Best all-around' },
    holographic: { label: 'Holographic', multiplier: 1.35, note: 'Rainbow shift' },
    clear: { label: 'Clear Vinyl', multiplier: 1.2, note: 'Borderless look' },
    reflective: { label: 'Reflective', multiplier: 1.55, note: 'Lights up at night' }
  };
  const prices = {
    2: { 25: 29, 50: 45, 100: 69, 250: 109, 500: 149, 1000: 229 },
    3: { 25: 39, 50: 59, 100: 89, 250: 139, 500: 219, 1000: 349 },
    4: { 25: 49, 50: 79, 100: 119, 250: 189, 500: 299, 1000: 499 },
    5: { 25: 59, 50: 95, 100: 139, 250: 239, 500: 389, 1000: 649 }
  };
  const sizes = [2, 3, 4, 5];
  const quantities = [25, 50, 100, 250, 500, 1000];
  const quantityNotes = { 100: 'Most popular', 500: 'Best for teams', 1000: 'Best bulk value' };
  const state = { material: 'vinyl', size: 3, quantity: 100 };
  const materialWrap = builder.querySelector('[data-material-options]');
  const sizeWrap = builder.querySelector('[data-size-options]');
  const quantityWrap = builder.querySelector('[data-quantity-options]');

  const normalizeMaterial = value => {
    const text = String(value || '').toLowerCase();
    if (text.includes('holo')) return 'holographic';
    if (text.includes('clear')) return 'clear';
    if (text.includes('reflect')) return 'reflective';
    if (text.includes('vinyl') || text.includes('standard')) return 'vinyl';
    return text.trim();
  };
  const normalizeNumber = value => Number(String(value || '').replace(/[^0-9.]/g, ''));
  const optionName = option => String(option?.name ?? option ?? '').toLowerCase();
  const optionIndex = name => optionNames.findIndex(option => optionName(option).includes(name));
  const indices = { material: optionIndex('material'), size: optionIndex('size'), quantity: optionIndex('quantity') };
  const materialCodes = { vinyl: 'SV', clear: 'CL', holographic: 'HO', reflective: 'RF' };
  const expectedTotal = () => Math.ceil(prices[state.size][state.quantity] * catalog[state.material].multiplier);
  function showBuilderError(message) { errorNode.textContent = message || ''; }
  function variantValues(variant) {
    if (Array.isArray(variant?.options)) return variant.options;
    return [variant?.option1, variant?.option2, variant?.option3].filter(value => value != null && value !== '');
  }
  function variantMatchesByPosition(variant) {
    if (Object.values(indices).some(index => index < 0)) return false;
    const values = variantValues(variant);
    return normalizeMaterial(values[indices.material]) === state.material
      && normalizeNumber(values[indices.size]) === state.size
      && normalizeNumber(values[indices.quantity]) === state.quantity;
  }
  function variantMatchesByValues(variant) {
    const values = variantValues(variant);
    return values.some(value => normalizeMaterial(value) === state.material)
      && values.some(value => normalizeNumber(value) === state.size)
      && values.some(value => normalizeNumber(value) === state.quantity);
  }
  function matchingVariant() {
    if (!product || !Array.isArray(product.variants)) return null;
    const expectedSku = `TS-${state.size}-${materialCodes[state.material]}-${String(state.quantity).padStart(4, '0')}`.toLowerCase();
    return product.variants.find(variant => String(variant.sku || '').trim().toLowerCase() === expectedSku)
      || product.variants.find(variantMatchesByPosition)
      || product.variants.find(variantMatchesByValues)
      || null;
  }
  function renderControls() {
    materialWrap.innerHTML = Object.entries(catalog).map(([id, material]) => `<button type="button" class="option ${state.material === id ? 'active' : ''}" data-material="${id}"><strong>${material.label}</strong><small>${material.note}${material.multiplier > 1 ? ` • +${Math.round((material.multiplier - 1) * 100)}%` : ''}</small></button>`).join('');
    sizeWrap.innerHTML = sizes.map(size => `<button type="button" class="${state.size === size ? 'active' : ''}" data-size="${size}">${size}″</button>`).join('');
    quantityWrap.innerHTML = quantities.map(quantity => `<button type="button" class="${state.quantity === quantity ? 'active' : ''}" data-quantity="${quantity}"><b>${quantity.toLocaleString()}</b>${quantityNotes[quantity] ? `<small>${quantityNotes[quantity]}</small>` : ''}</button>`).join('');
  }
  function updateOrder() {
    const total = expectedTotal();
    const variant = matchingVariant();
    const material = catalog[state.material];
    builder.querySelector('[data-order-title]').textContent = `${state.size}″ ${material.label}`;
    builder.querySelector('[data-price]').textContent = money(total * 100);
    builder.querySelector('[data-unit-price]').textContent = `${money((total * 100) / state.quantity)} each • ${state.quantity.toLocaleString()} stickers`;
    builder.querySelector('[data-property-material]').value = material.label;
    builder.querySelector('[data-property-size]').value = `${state.size} inch`;
    builder.querySelector('[data-property-quantity]').value = String(state.quantity);
    variantInput.value = variant?.id || '';
    if (!product) {
      addButton.disabled = true; addButton.textContent = 'Connect Shopify product'; showBuilderError('Import the matching product CSV or select your custom-sticker product in the theme editor.');
    } else if (!variant) {
      addButton.disabled = true; addButton.textContent = 'Variant not configured'; showBuilderError('This exact material, size, and quantity needs a matching Shopify variant.');
    } else if (Number(variant.price) !== total * 100) {
      addButton.disabled = true; addButton.textContent = 'Price needs syncing'; showBuilderError(`Shopify has this variant at ${money(variant.price)}; the approved price is ${money(total * 100)}.`);
    } else if (!variant.available) {
      addButton.disabled = true; addButton.textContent = 'Sold out'; showBuilderError('This combination is currently sold out.');
    } else {
      addButton.disabled = false; addButton.textContent = 'Add to cart'; showBuilderError('');
    }
  }

  builder.addEventListener('click', event => {
    const button = event.target.closest('[data-material],[data-size],[data-quantity]');
    if (!button) return;
    if (button.dataset.material) state.material = button.dataset.material;
    if (button.dataset.size) state.size = Number(button.dataset.size);
    if (button.dataset.quantity) state.quantity = Number(button.dataset.quantity);
    renderControls(); updateOrder();
  });
  document.querySelectorAll('[data-business-run]').forEach(link => link.addEventListener('click', () => {
    state.material = 'vinyl'; state.size = 3; state.quantity = 100;
    renderControls(); updateOrder();
  }));
  const artwork = builder.querySelector('[data-artwork]');
  const artworkDelivery = builder.querySelector('[data-artwork-delivery]');
  artwork?.addEventListener('change', event => {
    const file = event.target.files[0];
    const label = builder.querySelector('[data-file-label]');
    const status = builder.querySelector('[data-upload-status]');
    if (!file) { label.textContent = 'Choose PDF'; status.textContent = 'Upload one print-ready PDF, or send it after checkout.'; status.className = 'upload-status'; if (artworkDelivery) artworkDelivery.value = 'Send PDF after checkout'; return; }
    const valid = file.name.toLowerCase().endsWith('.pdf') && (!file.type || file.type === 'application/pdf');
    if (!valid) { event.target.value = ''; label.textContent = 'Choose PDF'; status.textContent = 'That file is not a valid PDF selection. Please choose an actual .pdf file.'; status.className = 'upload-status error'; if (artworkDelivery) artworkDelivery.value = 'Send PDF after checkout'; showToast('PDF files only'); return; }
    label.textContent = 'PDF selected'; status.textContent = `Ready: ${file.name}`; status.className = 'upload-status success'; if (artworkDelivery) artworkDelivery.value = 'PDF uploaded';
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!variantInput.value || addButton.disabled) { showBuilderError('Choose an available, correctly priced combination before adding it to your cart.'); return; }
    addButton.disabled = true; addButton.textContent = 'Adding…';
    try {
      const response = await fetch(config.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) { const data = await response.json().catch(() => ({})); throw new Error(data.description || 'This order could not be added to the cart.'); }
      await refreshCart(); openCart(true); showToast('Added to cart');
    } catch (error) { showBuilderError(error.message); showToast('Could not add to cart'); }
    updateOrder();
  });
  renderControls(); updateOrder();
})();
